import { WidgetTypes } from "legacy/constants/WidgetConstants";

export const SettableWidgets: readonly WidgetTypes[] = [];
